import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const ActiveFilters = styled.div`
  font-size: 0;
  padding-top: ${({ theme }) => theme.spacings.x3};

  ${breakpoints.MD} {
    padding-top: 0;
  }

  ${breakpoints.MD} {
    padding-top: ${({ theme }) => theme.spacings.x3};
  }
`;

const Filter = styled.div`
  background-color: ${({ theme }) => theme.colors.divider};
  padding: 4px ${({ theme }) => theme.spacings.base} 4px
    ${({ theme }) => theme.spacings.x2};
  display: inline-flex;
  border-radius: ${({ theme }) => theme.spacings.x5};
  margin-right: ${({ theme }) => theme.spacings.x2};
  margin-bottom: ${({ theme }) => theme.spacings.x2};
  justify-content: center;
  align-items: center;
`;

const Label = styled.span`
  font-size: 12px;
  line-height: 18px;
  text-transform: uppercase;
`;

const Count = styled.span`
  font-size: 12px;
  line-height: 1;
  margin: 0 8px;
  color: ${({ theme }) => theme.colors.text.grey};
`;

const Action = styled.button`
  position: relative;
  height: 18px;
  width: 18px;
  transform: rotate(-45deg);

  &:before,
  &:after {
    content: '';
    position: absolute;
    background-color: #fff;
    border-radius: 1px;
    transition: background-color 0.1s ease-in-out;
  }

  &:before {
    height: 1px;
    width: 10px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  &:after {
    width: 1px;
    height: 10px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &:hover {
    &:before,
    &:after {
      background-color: ${({ theme }) => theme.colors.secondary.second};
    }
  }

  &:active {
    &:before,
    &:after {
      background-color: ${({ theme }) => theme.colors.primary.first};
    }
  }
`;

export { ActiveFilters, Filter, Label, Count, Action };
